import { Typography, Box, Alert } from '@mui/material';

export interface ThankYouTranslations {
  thankYou: string;
  verification: string;
  [key: string]: string;
}

interface ThankYouMessageProps {
  t: ThankYouTranslations;
}

const ThankYouMessage: React.FC<ThankYouMessageProps> = ({ t }) => (
  <Box className="thank-you-message">
    <Alert severity="success" sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>{t.thankYou}</Typography>
      <Typography>{t.verification}</Typography>
    </Alert>
  </Box>
);

export default ThankYouMessage;
